import { render, staticRenderFns } from "./ChatDoctor.vue?vue&type=template&id=0c4c511e&scoped=true"
import script from "./ChatDoctor.vue?vue&type=script&lang=js"
export * from "./ChatDoctor.vue?vue&type=script&lang=js"
import style0 from "./ChatDoctor.vue?vue&type=style&index=0&id=0c4c511e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c511e",
  null
  
)

export default component.exports